import { Activity } from 'src/types';

export const getReferrerCompanyName = (allActivities: Activity[], jobKey: string) => {
  return 'Referrer';
};
